import { Component, OnInit, ChangeDetectorRef, Injector } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { of, OperatorFunction, Subscription } from 'rxjs';
import { tap, filter, mergeMap, map } from 'rxjs/operators';
import { CompetitionInitService } from '../services/competition-init.service';
import { IThirdNavCollapsibleElement } from '../../common-page-components/third-nav-tab-component/third-nav-tab-component.component';
import { trigger, transition, style, animate, query, animateChild, state } from '@angular/animations';
import { IEvents } from 'src/app/common-page-components/stores/entities-store/events-store';
import { ICompetitionsNews } from 'src/app/common-page-components/stores/entities-store/competitions-news-store';
import { ITabPhotoContent } from 'src/app/common-page-components/stores/entities-store/competitions-gallery.store.';
import { catchError } from 'rxjs/operators/';
import { ICompetitionDocumentResult } from 'src/app/common-page-components/stores/entities-store/competition-documents-store';
import { CompetitionEntriesStore } from '../../common-page-components/stores/entities-store/competitions-entries.store';
import { HttpClient } from '@angular/common/http';
import { ICompetitionsDayReviewNews } from '../../common-page-components/stores/entities-store/competitions-day-review-news-store';

@Component({
  selector: 'app-bootstrap-competitions',
  templateUrl: './bootstrap-competitions.component.html',
  styleUrls: ['./bootstrap-competitions.component.scss'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
        query('@*', animateChild(), { optional: true }),

      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 })),
        query('@*', animateChild(), { optional: true }),
      ])
    ]),
    trigger('navigate', [
      state('in', style({ 'opacity': '1' })),
      state('out', style({ 'opacity': '0' })),

      transition('* <=> *', [
        query('@*', animateChild(), { optional: true }),
        animate('1500ms')
      ])
    ]),
    trigger('heightAnimation', [
      transition(':enter', [
        query('@*', animateChild(), { optional: true }),
        style({ height: 0, paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 0 }),
        animate('1000ms', style({ height: '*', opacity: 1 }))
      ]),

      transition(':leave', [
        query('@*', animateChild(), { optional: true }),
        style({ height: '*', paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 1 }),
        animate('1000ms', style({ height: 0, paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 0 })),

      ]),

      transition('* <=> *', [
        query('@*', animateChild(), { optional: true }),
        animate('500ms')
      ]),

    ]),
  ],
})
export class BootstrapCompetitionsComponent implements OnInit {
  subscriptions: Array<Subscription> = [];
  /**
   * Map between pages and their specific title, pretitle, and image.
   *
   * @memberof BootstrapMembersTabsComponent
   */
  mapRoutesWithTabs = {
    'default': {
      'image': '../../../../../modules/custom/wa_angular/app/assets/images/members-background-img.jpg',
      'pretitle': 'Event',
      'title': 'Event'
    }
  };

  /**
   * The news array.
   *
   * @memberof BootstrapCompetitionsComponent
   */
  news: Array<ICompetitionsNews>;


  /**
   * The day review news array.
   *
   * @memberof BootstrapCompetitionsComponent
   */
  day_review_news: Array<ICompetitionsDayReviewNews>;

  /**
   * The photos array.
   *
   * @memberof BootstrapCompetitionsComponent
   */
  photos: Array<ITabPhotoContent> = [];

  /**
   * Data for get the documents.
   *
   * @type {ICompetitionDocumentResult}
   * @memberof BootstrapCompetitionsComponent
   */
  documents: ICompetitionDocumentResult;
  urlInclude: string;

  comp;
  public routes: IThirdNavCollapsibleElement[] = [
    { name: 'competition.tab.event', route: './' },
    { name: 'competition.tab.ranking', route: 'ranking' },
    { name: 'competition.tab.results', route: 'results' },
    { name: 'competition.tab.entries', route: 'entries', matchesRoutes: ['entries/news', 'entries/photos', 'entries/quotes', 'entries/results'] },
    { name: 'competition.tab.quotes', route: 'quotes' },
    { name: 'competition.tab.photos', route: 'photos' },
    { name: 'competition.tab.news', route: 'news' },

  ]

  constructor(
    protected http: HttpClient,
    protected injector: Injector,
    public _route: ActivatedRoute,
    private ch: ChangeDetectorRef,
    public competition_service: CompetitionInitService,
    protected router: Router,
  ) { }


  ngOnInit() {
    this.subscriptions.push(this._route.params.pipe(
      filter(a => a.id != undefined),
      mergeMap(params => {
        if (params.name && params.id) {
          window['wa_angular'] = {
            'compId': params.id
          };
          // TO DO add logic and page for competitions not allowed.
          return this.competition_service.competitionStore.requestData({ CompId: params.id, Detailed: 1 }, false).pipe(
            tap(competition => {
            }
            ),
            this.requestNews(),
            this.requestDayReviewNews(),
            this.requestPhotos(),
            this.requestDocuments(),
            this.requestEditorialInformation(),
            this.requestEntries(),
            this.requestQuotes(),


            this.requestRankings()
          )
        } else {
          return this.competition_service.competitionStore.requestData({ CompId: params.id, Detailed: 1 }, false)
            .pipe(
              map(a => this.competition_service.competitionStore.data[0]),
              tap(competition => {
                this.comp = competition as IEvents;
                if (this.comp.Name) {
                  this.router.navigate(['/competition', this.comp.ID, this.prepareNameForRoute(this.comp.Name)]);
                }
              }),
              this.requestNews(),
              this.requestPhotos(),
              this.requestDocuments(),
              this.requestEditorialInformation(),
              this.requestEntries(),
              this.requestQuotes(),

              this.requestRankings()
            )
        }
      }),
      tap(a => {
        this.news = Array.from(this.competition_service.competitionNewsStore.data) as any;
        this.day_review_news = Array.from(this.competition_service.competitionDayReviewNewsStore.data) as any;
        this.photos = Array.from(this.competition_service.competitionGalleryStore.data);
        const entries = (a as CompetitionEntriesStore).data;
        const resultTab =
          this.competition.IsLive == true ? {
            name: 'competition.tab.results', route: 'results'
          } :
            this.competition.WithRes == false && !this.competition.Links['Result URL'] ? undefined
              :
              this.competition.WithRes == false && this.competition.Links['Result URL'] ?

                { name: 'competition.tab.results', external: true, route: this.competition.Links['Result URL'] }
                : this.competition.WithRes ? {
                  name: 'competition.tab.results', route: 'results'
                } : undefined;
        const routes = [
          { name: 'competition.tab.event', route: './', mustBeFullCheck: true },
          this.competition_service.rankingStore.data.length > 0 ? { name: 'competition.tab.ranking', route: 'ranking' } : undefined,
          resultTab,
          entries.length > 0 ? { name: 'competition.tab.entries', route: 'entries', matchesRoutes: ['entries/news', 'entries/photos', 'entries/quotes', 'entries/results'] } : undefined,
          this.competition_service.competitionQuotes.data.length > 0 ? { name: 'competition.tab.quotes', route: 'quotes' } : undefined,
          { name: 'competition.tab.photos', route: 'photos', mustBeFullCheck: true, },
          { name: 'competition.tab.news', route: 'news', mustBeFullCheck: true, },

        ].filter(Boolean);
        console.log(this.competition_service.rankingStore.data)
        this.routes = (routes as IThirdNavCollapsibleElement[]).map(router => {
          return {
            name: router.name,
            external: router.external,
            matchesRoutes: router.matchesRoutes,
            mustBeFullCheck: router.mustBeFullCheck,
            route: router.route.replace('id', this.competition.ID.toString()).replace('compname', this.prepareNameForRoute(this.competition.Name))
          }
        });
        this.clearRoutes();
      }),


    ).subscribe(next => {

    }));

  }
  /**
   * A method for clear routes when no data is present.
   *
   * @memberof BootstrapCompetitionsComponent
   */
  clearRoutes() {
    let index;
    if (this.news && this.news.length === 0) {
      index = this.routes.findIndex(route => route.name.includes('news'));
      index > -1 ? this.routes.splice(index, 1) : undefined;
    }
    if (this.photos && this.photos.length === 0) {
      index = this.routes.findIndex(route => route.name.includes('photos'));
      index > -1 ? this.routes.splice(index, 1) : undefined;
    }
  }
  /**
   * A method for request the news from the store.
   * @returns {OperatorFunction}
   * @memberof BootstrapCompetitionsComponent
   */
  requestNews() {
    return mergeMap(a => {
      this.competition_service.competitionNewsStore.competition_id = this.competition.ID.toString();
      return this.competition_service.competitionNewsStore.requestData({}, false).pipe(
        map(
          value => a
        ),
        catchError(e => of(a))

      );
    });
  }

  /**
   * A method for request the day review news from the store.
   * @returns {OperatorFunction}
   * @memberof BootstrapCompetitionsComponent
   */
  requestDayReviewNews() {
    return mergeMap(a => {
      this.competition_service.competitionDayReviewNewsStore.competition_id = this.competition.ID.toString();
      return this.competition_service.competitionDayReviewNewsStore.requestData({}, false).pipe(
        map(
          value => a
        ),
        catchError(e => of(a))

      );
    });
  }

  /**
 * Method for check if there's any quote and return the properly navigation bar.
 *
 * @returns
 * @memberof BootstrapCompetitionsComponent
 */
  requestQuotes() {
    return mergeMap(a => {
      const date = new Date();
      this.competition_service.competitionQuotes.competition_id = this.competition.ID.toString();
      return this.competition_service.competitionQuotes.requestData({
        date_to: new Date(
        ).toISOString().slice(0, 11) + '23:59:59'

      }, false).pipe(
        map(value => a),
        catchError(e => of(a))
      )
    });
  }


  /**
   * Method for check if there's any entry and return the properly navigation bar.
   *
   * @returns
   * @memberof BootstrapCompetitionsComponent
   */
  requestEntries() {
    return mergeMap(a => {
      const entriesStore = new CompetitionEntriesStore(this.http, this.injector);
      return entriesStore.requestData({ 'CompId': this.competition.ID.toString() }, false).pipe(
        map(value => entriesStore),
        catchError(e => of(entriesStore))
      )
    });
  }

  /**
   * A method for request photos from the store.
   * @returns {OperatorFunction}
   * @memberof BootstrapCompetitionsComponent
   */
  requestPhotos() {
    return mergeMap(a => {
      this.competition_service.competitionGalleryStore.competition_id = this.competition.ID.toString();
      return this.competition_service.competitionGalleryStore.requestData({}, false).pipe(
        map(
          value => a
        ),
        catchError(e => of(a))
      );
    });
  }

  /**
   * Method for request the rankings and hide tab when no data is available.
   *
   * @returns
   * @memberof BootstrapCompetitionsComponent
   */
  requestRankings() {
    return mergeMap(a => {
      return this.competition_service.rankingStore.requestData({ CompId: this.competition.ID.toString() }, false)
        .pipe(
          map(value => a),
          catchError(e => of(a))
        )
    })
  }

  /**
   * Method for obtain documents from tofficial service.
   *
   * @returns
   * @memberof BootstrapCompetitionsComponent
   */
  requestDocuments() {
    return mergeMap(a => {
      this.competition_service.competitionDocumentsStore.competition_id = this.competition.ID.toString();
      return this.competition_service.competitionDocumentsStore.requestData({}, false).pipe(
        map(
          value => a
        ),
        catchError(e => of(a))
      )
    })
  }

  /**
   * Method for request the editorial information of a competition.
   *
   * @returns
   * @memberof BootstrapCompetitionsComponent
   */
  requestEditorialInformation() {
    return mergeMap(a => {
      return this.competition_service.competitionEditorialInformationStore.requestData({ 'competition_id': this.competition.ID.toString() }, false);
    })
  }

  /**
   * A method for prepare the competition name for route
   * @returns {string} the competition name with '-' instead spaces.
   * @memberof BootstrapCompetitionsComponent
   */
  prepareNameForRoute(name: string) {
    return this.competition_service.prepareNameForRoute(name);
  }

  /**
   * A getter for get the competition data.
   * @returns {OperatorFunction}
   * @memberof BootstrapCompetitionsComponent
   */
  get competition() {
    return this.competition_service.competitionStore.data && this.competition_service.competitionStore.data.length > 0 ? this.competition_service.competitionStore.data[0] : undefined;
  }

  /**
   * Function to provide the propertly banner
   *
   * @param {IEvents} competition
   * @returns
   * @memberof BootstrapCompetitionsComponent
   */
  provideBanner(competition: IEvents) {
    if ((competition.HeaderImage as any) instanceof Array) {
      return this.selectBannerById(competition);
    } else {
      if (competition.HeaderImage == null || competition.HeaderImage.URL == null
        || competition.HeaderImage.URL === '' || competition.HeaderImage.URL.length === 0) {
        return this.selectBannerById(competition);
      } else {
        return competition.HeaderImage.URL;
      }
    }
  }

  /**
   * Method for select the image using the competition id.
   *
   * @param {IEvents} competition The competition id.
   * @returns
   * @memberof BootstrapCompetitionsComponent
   */
  selectBannerById(competition: IEvents) {
    let compId;
    if ((competition.ComDis as any) instanceof Array) {
      compId = Math.min.apply(Math, competition.ComDis)
    } else {
      compId = competition.ComDis;
    }
    let path = "/modules/custom/wa_angular/app/assets/competitions/images/header/BACK-UP-ID";
    switch (compId) {
      case 1:
        path = path + compId.toString()
        break;
      case 2:
        path = path + compId.toString()
        break;
      case 3:
        path = path + compId.toString()
        break;
      case 4:
        path = path + compId.toString()
        break;
      case 9:
        path = path + compId.toString()
        break;
      default:
        path = path + "1"
    }
    return path + ".jpg";
  }

  get activeRoute() {
    const activeRoute = this.router.url.split('?')[0].split('/').pop();
    if (activeRoute === 'news') {
      return 'initial';
    }
    return '0';
  }
}
